import { fetchJson } from 'utils/fetchJson/fetchJson';
import { PAYEX_URL } from '../../../constants';
import { fetch } from '../fetch';
import type { CreateUserRequestBody } from './types';

const users = {
  create: ({ locale = 'EN', ...attributes }: CreateUserRequestBody) => {
    const path = `${PAYEX_URL}/users?locale=${locale}`;
    const body = JSON.stringify(attributes);

    return fetchJson(path, { method: 'POST', body });
  },

  update: ({ locale = 'EN', ...attributes }) => {
    const path = `${PAYEX_URL}/users/me?locale=${locale}`;
    const body = JSON.stringify(attributes);

    return fetch(path, { method: 'PATCH', body });
  },

  fetchUser: () => {
    const path = `${PAYEX_URL}/users/me`;
    const options = {
      method: 'GET',
    };

    return fetch(path, options);
  },

  changePassword: ({ password, resetPasswordToken }) => {
    const path = `${PAYEX_URL}/users/password`;
    const body = JSON.stringify({
      password: password,
      reset_password_token: resetPasswordToken,
    });

    const options = {
      method: 'PUT',
      body,
    };

    return fetch(path, options);
  },

  userExists: ({ email, token = '' }) => {
    const path = `${PAYEX_URL}/users/email`;
    const options = {
      method: 'POST',
      body: JSON.stringify({ email }),
      headers: {
        'X-Proxy-Authorization': `Bearer ${token}`,
      },
    };

    return fetchJson(path, options);
  },
};

export { users };
